/**
 * Ter'fa (382) deploy: coalesce three Shadow Sniper flies into one sequential batch.
 */
export function coalesceTerfaShadowSniperFlyBatch(grants) {
  if (!grants?.length) {
    return [];
  }

  const passthrough = [];
  const terfaGroups = new Map();

  grants.forEach((grant) => {
    if (grant?.source !== 'terfa_382' || !grant?.key) {
      passthrough.push(grant);
      return;
    }
    const keyParts = String(grant.key).split(':');
    if (keyParts.length < 3) {
      throw new Error(`coalesceTerfaShadowSniperFlyBatch: invalid grant key ${grant.key}`);
    }
    const providerInstanceId = keyParts[1];
    const groupKey = `${providerInstanceId}:${grant.zone}:${grant.index}`;
    if (!terfaGroups.has(groupKey)) {
      terfaGroups.set(groupKey, []);
    }
    terfaGroups.get(groupKey).push(grant);
  });

  terfaGroups.forEach((group) => {
    const sorted = [...group].sort(
      (a, b) => (a.sequenceIndex ?? 0) - (b.sequenceIndex ?? 0)
    );
    if (sorted.length === 1) {
      passthrough.push(sorted[0]);
      return;
    }
    const providerInstanceId = String(sorted[0].key).split(':')[1];
    const batchOrderInstanceIds = sorted.map((g) => String(g.orderInstanceId));
    passthrough.push({
      ...sorted[0],
      key: `terfa-batch:${providerInstanceId}:${batchOrderInstanceIds.join('_')}`,
      batchGrants: sorted,
      batchOrderInstanceIds,
    });
  });

  return passthrough;
}
